/* The value chart (U-32), after DefiLlama's TVL chart. Colours are the page
   tokens: --signal for the line, --up / --down for flows, --caution for
   coverage markers. */

.chart {
  padding: 10px 12px 8px;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 16px;
  margin-bottom: 6px;
}

.value {
  color: var(--ink);
  font-family: var(--mono);
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.change {
  min-height: 1.2em;
  font-family: var(--mono);
  font-size: 0.78rem;
}

.muted {
  color: var(--ink-muted);
}

.tools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.presets {
  display: inline-flex;
  border: 1px solid var(--line-strong);
  border-radius: 6px;
  overflow: hidden;
}

.preset {
  min-height: 26px;
  padding: 0 9px;
  border: 0;
  background: transparent;
  color: var(--ink-muted);
  cursor: pointer;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.preset + .preset {
  border-left: 1px solid var(--line-strong);
}

.preset:hover {
  color: var(--ink);
}

.preset[data-active="true"] {
  background: var(--signal-fill);
  color: var(--on-signal);
}

.export {
  min-height: 26px;
  padding: 0 8px;
  border: 1px solid var(--line-strong);
  border-radius: 6px;
  background: transparent;
  color: var(--signal);
  cursor: pointer;
  font-family: var(--mono);
  font-size: 0.68rem;
}

.export:disabled {
  color: var(--ink-muted);
  cursor: default;
}

.frame {
  position: relative;
}

.empty {
  margin: 0;
  padding: 40px 0;
  color: var(--ink-muted);
  font-size: 0.8rem;
  text-align: center;
}

.svg {
  display: block;
  max-width: 100%;
  touch-action: pan-y;
}

.svg:focus-visible,
.brush:focus-visible {
  outline: 1px solid var(--signal);
  outline-offset: 2px;
}

.grid {
  stroke: var(--line);
  stroke-width: 1;
  opacity: 0.6;
}

.axis {
  fill: var(--ink-muted);
  font-family: var(--mono);
  font-size: 10px;
}

.gradTop {
  stop-color: var(--signal);
  stop-opacity: 0.35;
}

.gradBottom {
  stop-color: var(--signal);
  stop-opacity: 0;
}

.line {
  fill: none;
  stroke: var(--signal);
  stroke-width: 2;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.marker {
  fill: var(--caution);
}

.flowIn {
  fill: var(--up);
}

.flowOut {
  fill: var(--down);
}

.crosshair {
  stroke: var(--ink-muted);
  stroke-width: 1;
  stroke-dasharray: 3 3;
}

.dot {
  fill: var(--signal);
  stroke: var(--paper, #0b0b0d);
  stroke-width: 2;
}

.tooltip {
  position: absolute;
  top: 8px;
  z-index: 2;
  min-width: 150px;
  max-width: 220px;
  padding: 7px 9px;
  border: 1px solid var(--line-strong);
  border-radius: 8px;
  background: rgba(16, 15, 20, 0.95);
  color: var(--ink);
  font-family: var(--mono);
  font-size: 0.72rem;
  line-height: 1.45;
  pointer-events: none;
}

.tipDate {
  color: var(--ink-muted);
}

.tipValue {
  font-weight: 700;
}

.tipEstimated {
  margin-left: 6px;
  color: var(--caution);
  font-weight: 400;
}

.tipEvent {
  color: var(--caution);
}

.brush {
  display: block;
  margin-top: 4px;
  cursor: grab;
  touch-action: none;
}

.brushBg {
  fill: rgba(255, 255, 255, 0.02);
  stroke: var(--line);
}

.brushLine {
  fill: none;
  stroke: var(--ink-muted);
  stroke-width: 1;
  opacity: 0.7;
}

.brushSel {
  fill: var(--signal);
  fill-opacity: 0.14;
  stroke: var(--signal);
  stroke-opacity: 0.6;
}

.handle {
  fill: var(--signal);
  cursor: ew-resize;
}

@media (prefers-reduced-motion: no-preference) {
  .line {
    transition: d 200ms ease-out;
  }
}
